import { StorageState } from '../../../../reducers';
import { createDataFetchSliceSelectors } from '../../../../utils/dataFetch';


export const adminAccountStatisticBalanceSliceSelector = (state: StorageState) => state.adminAccount.statistic.balance;

export const adminAccountStatisticBalanceSelectors = createDataFetchSliceSelectors(
    adminAccountStatisticBalanceSliceSelector
);
